import { defineStore } from 'pinia';
import { mergeStores } from '@/store/helpers';
import mdSearchConfig from '../../md-search/_store/config';
import mdSearchBarConfig from './config';

export default (storeName, pinia) => defineStore(storeName, mergeStores(mdSearchConfig, mdSearchBarConfig(pinia)));